import { css } from 'lit';

export const guildViewStyles = css`

  view-content {
    padding-top: 6.5rem;
  }

  /*=== GUILD HEADER ===*/

  guild-header {
    display: block;
    position: relative;

    max-width: var(--q1-view-width);
    padding: 2rem;
    margin: 0 -1rem 0 -1rem;
    border-radius: 10rem;
    overflow: hidden;
    border: 1px solid var(--theme-color-secondary);
    background: var(--dm-white);
    box-shadow: var(--sl-shadow-x-small);
  }
  @media (min-width: 650px) {
    guild-header {
      margin: 0 auto 0 auto;
    }
  }

  guild-banner {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: var(--guild-banner-opacity);
  }
  guild-banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  guild-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: var(--theme-color-secondary);
    opacity: var(--guild-overlay-opacity);
  }

  guild-header-content {
    display: flex;
    position: relative;
    gap: 1rem;
    align-items: center;
    color: var(--theme-text-color-secondary);
  }
  @media (min-width: 650px) {
    guild-header-content {
      gap: 1.5rem;
    }
  }

  sl-avatar#guild-avatar {
    --size: 6rem;
  }
  sl-avatar#guild-avatar::part(base) {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .guild-header-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .guild-header-info h1 {
    font-size: 1.3rem;
    line-height: 1.2em;
    font-weight: 500;
    margin: 0;
  }
  @media (min-width: 650px) {
    .guild-header-info h1 {
      font-size: 2rem;
    }
  }

  .guild-header-info ul {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .guild-header-info ul li {
    gap: 0.5rem;
    align-items: center;
    font-size: 1rem;
    line-height: 1em;
    color: var(--theme-text-color-secondary);
    opacity: 0.7;
    transition: opacity 0.2s;
  }
  .guild-header-info ul li:not(.hide-at-bp2):not(.hide-until-bp2) {
    display: flex;
  }
  .guild-header-info ul li:hover {
    opacity: 1;
  }
  .guild-header-info ul li sl-icon {
    color: var(--theme-text-color-secondary);
  }

  guild-subheader {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin: 1.5rem 0;
    padding: 0;
  }

  guild-subheader .inner-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1 1 auto;
    text-align: justify;
  }

  guild-subheader button-bar {
    flex: 0 0 auto;
    flex-wrap: wrap;
    justify-content: flex-end;
    
    width: 100%;
  }
  guild-subheader button-bar .info {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 0.35rem;

    color: var(--dm-gray-6);
    font-weight: 300;
    font-style: italic;
  }
  guild-subheader button-bar sl-button.menu-button::part(base) {
    padding-right: 0;
  }

  sl-menu-item {
    font-style: normal;
  }

  .external-icon {
    font-size: 1.5rem;
    display: inline-flex;
    align-items: center;
    color: var(--dm-gray-6);
    vertical-align: middle;
  }

  .external-icon:hover {
    color: var(--dm-gray-7);
  }

  sl-button.external-icon-button::part(label) {
    padding: 0;
    margin: 0;
  }

  sl-button.external-icon-button::part(caret) {
    color: var(--dm-gray-6);
  }

  sl-button.external-icon-button:hover::part(caret) {
    color: var(--dm-gray-7);
  }

  sl-button.external-icon-button::part(base) {
    padding: 0;
  }

  .external-icon-link {
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    line-height: 1;
  }

  #guild-headline {
    color: var(--dm-gray-7);
  }

  @media(min-width: 650px) {
    guild-subheader {
      padding: 0 2.5rem;
    }
  }

  /*=== SHARED STYLES ===*/

  sl-tab-panel h1 {
    font-size: 1.5rem;
    line-height: 1.3em;
    font-weight: 600;
  }

  h3 {
    font-size: 1.1rem;
    line-height: 1.3em;
    font-weight: 500;
    color: var(--gray-7);
  }

  h3.with-border {
    border-bottom: 1px solid var(--gray-3);
    padding-bottom: 0.75rem;
  }

  q1-alert-bar#activation-bar {
    max-width: var(--q1-view-width);
    margin: -1rem auto var(--view-item-spacing) auto;
  }

  /*=== TAB CONTENT ===*/

  sl-tab-panel {
    --padding: var(--view-item-spacing) 0;

    --link-color-default: var(--theme-color-primary-6);
    --link-color-visited: var(--theme-color-primary-6);
    --link-color-focus: var(--theme-color-primary-8);
  }

  sl-tab-panel header-bar {
    margin-bottom: 0;
  }
  
  sl-tab-panel header-bar.with-border {
    padding-bottom: 1rem;
  }

  sl-tab-panel q1-markdown {
    margin-top: var(--view-item-spacing);
  }

  sl-tab-panel empty-alert {
    margin-top: var(--view-item-spacing);
  }

  button-bar {
    flex-wrap: nowrap;
    gap: 0.5rem;
  }
  button-bar sl-button.menu-button::part(base) {
    color: var(--dm-gray-7);
  }

  .organizers {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  q1-membership-list {
    margin-top: var(--view-item-spacing);
  }

  /*=== HOME TAB ===*/

  #log-items-list {
    display: flex;
    flex-direction: column;
    gap: var(--view-item-spacing);
  }

  .no-more-pages {
    padding: 1rem;
    width: 100%;
    text-align: center;
  }
  .no-more-pages span {
    margin: 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    gap: 0.5rem;
    color: var(--gray-7);
    font-style: italic;
    font-weight: 200;
  }

  avatar-stack {
    --avatar-border-color: var(--dm-gray-1);
    --avatar-stack-size: 1.6rem;
    margin-bottom: 0.5rem;
  }
  
`;